
import superagent from "superagent";
import { authorize } from "../helper/authorize-token";

const FETCH_CSS = "FETCH_CSS";
const ON_EDIT_CSS = "ON_EDIT_CSS";
const UPDATE_CSS = "UPDATE_CSS";

const deep_copy = obj => {
  return JSON.parse(JSON.stringify(obj));
};

const getAllCSS = () => {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_CSS,
      payload: superagent
        .get("/api/css/getAllCSS")
        .use(authorize(getState())),
    });
  };
}

const editCSS = (isEditing, selectedWlf) => {
  console.log("editCSS", isEditing, selectedWlf);
  return (dispatch, getState) => {
    dispatch({
      type: ON_EDIT_CSS,
      isEditingCSS: isEditing,
      selectedWlf: selectedWlf,
    });
  }
};

const UpdateCSS = selectedWlf => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_CSS,
      selectedWlf: selectedWlf,
    })
  }
};

const UploadFile = (file, wlf_id, field, token) => {

  const form_data = new FormData();
  form_data.append("file", file);
  form_data.append("wlf_id", wlf_id);
  form_data.append("field",field);

  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/css/upload-2")
      .send(form_data)
      .use(authorize(token))
      .then( res => {
        resolve(res.body.data.uploaded);
      })
  })
};

const SaveCSS = (wlf_css, token) => {

  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/css/updateCSS-2")
      .send({ data: wlf_css })
      .use(authorize(token))
      .then(() => {
        resolve();
      });
  });
};

const Clone = (wlf_id, token) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/css/clone")
      .send({ wlf_id })
      .use(authorize(token))
      .then(result => {
        resolve();
      })
  })
};

const Delete = (wlf_id, token) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/css/delete")
      .send({ wlf_id })
      .use(authorize(token))
      .then(resolve);
  })
}

const cssDashboardReducer = (
  state = {
    isFetching: true,
    error: null,
    allCSS: null,
    isEditingCSS: false,
    selectedWlf: '',
  }, action) => {
  switch (action.type) {
    case UPDATE_CSS:
      const new_state = deep_copy(state);
      const selectedWlf = action.selectedWlf;
      const id = selectedWlf.css.id;
      new_state.allCSS[id] = deep_copy(selectedWlf);
      return new_state;
    case FETCH_CSS + "_PENDING":
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case FETCH_CSS + "_FULFILLED":
      return {
        ...state,
        isFetching: false,
        error: null,
        allCSS:action.payload.body.data
      };
    case FETCH_CSS + "_REJECTED":
      return {
        ...state,
        isFetching: false,
        error: "ERROR",
        data: null
      };
    case ON_EDIT_CSS:
      return {
        ...state,
        isEditingCSS: action.isEditingCSS,
        selectedWlf: action.selectedWlf
      };
    default:
      return state;
  }
};

export { cssDashboardReducer, getAllCSS, editCSS, UploadFile, SaveCSS,
  UpdateCSS, Clone, Delete };
